export type ChainSource = 'whatsmychaincert' | 'ct-log' | 'crt.sh' | 'aia' | 'system-roots' | 'server';

export interface DiscoveredChain {
  /** leaf (or precert) first, then issuers upward */
  chain: Uint8Array[];
  subjects: string[];
  /** true when the last certificate is self-signed */
  endsAtRoot: boolean;
  source: ChainSource;
  /** where exactly it came from (log name + index, crt.sh, AIA URLs) */
  detail: string;
}

export const SOURCE_LABEL: Record<ChainSource, string> = {
  whatsmychaincert: 'whatsmychaincert.com',
  'ct-log': 'a CT log entry',
  'crt.sh': 'crt.sh',
  aia: 'AIA (Authority Information Access)',
  'system-roots': "the operating system's trust store",
  server: 'the server itself (TLS handshake)',
};
